// flow
export function isKiwiBranding(branding) {
  return branding.get("id") === "kiwicom"
}
